import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatOptionModule} from '@angular/material/core';
import {MatDialogModule} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {RevertModalComponent} from './revert-modal.component';

@NgModule({
  imports: RevertModalModule.IMPORTS,
  declarations: RevertModalModule.DECLARATIONS,
  exports: RevertModalModule.DECLARATIONS
})
export class RevertModalModule {
  public static readonly IMPORTS = [
    CommonModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    MatSelectModule,
    MatOptionModule
  ];

  public static readonly DECLARATIONS = [RevertModalComponent];
}
